module.exports = __webpack_public_path__ + "media/common/img/disappointed_robot-055bf1189af095c46f8043970b2773af.svg";